import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { ListItemIcon, ListItemText, Typography } from '@mui/material'
import React from 'react'
import Stack from '@mui/material/Stack';

const EstatusEmpleado = (props) => {
    switch (props.status) {
        case 'Alta':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#017630' }}> <CheckCircleOutlineIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#017630' }}> {props.status}</ListItemText>
                    </Stack>
                </>
            )
        case 'Reingreso':
            return (
                <>
                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF8A00' }}> <SwapHorizIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF8A00' }}> {props.status}</ListItemText>
                    </Stack>


                </>
            )
        case 'Baja':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#C70000' }}> <ArrowDownwardIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#C70000' }}> {props.status}</ListItemText>
                    </Stack>

                </>
            )

        default:
            return (
                <>
                </>
            )

    }
}

export default EstatusEmpleado
